import { ref, computed } from 'vue';
import { pricingService, DEFAULT_TAX_RATE } from '../services/pricing.service';
export function usePricing(options = {}) {
    const netPrice = ref(options.initialNetPrice ?? 0);
    const commissionAmount = ref(options.initialCommissionAmount ?? 0);
    const commissionType = ref(options.initialCommissionType ?? 'PERCENTAGE');
    const priceType = ref(options.initialPriceType ?? 'PERSON');
    const taxRate = ref(options.taxRate ?? DEFAULT_TAX_RATE);
    const totalPrice = computed(() => {
        return pricingService.calculateTotalPrice({
            netPrice: netPrice.value,
            commissionAmount: commissionAmount.value,
            commissionType: commissionType.value,
            taxRate: taxRate.value,
        });
    });
    const breakdown = computed(() => {
        return pricingService.getPriceBreakdown({
            netPrice: netPrice.value,
            commissionAmount: commissionAmount.value,
            commissionType: commissionType.value,
            taxRate: taxRate.value,
        });
    });
    const commissionInCurrency = computed(() => {
        return pricingService.getCommissionInCurrency(netPrice.value, commissionAmount.value, commissionType.value);
    });
    const formattedTotal = computed(() => pricingService.formatCurrency(totalPrice.value));
    const formattedNet = computed(() => pricingService.formatCurrency(netPrice.value));
    const formattedCommission = computed(() => pricingService.formatCurrency(commissionInCurrency.value));
    function setNetPrice(value) {
        netPrice.value = Math.max(0, value);
    }
    function setCommissionAmount(value) {
        commissionAmount.value = Math.max(0, value);
    }
    function setCommissionType(type) {
        commissionType.value = type;
    }
    function setPriceType(type) {
        priceType.value = type;
    }
    function reset() {
        netPrice.value = options.initialNetPrice ?? 0;
        commissionAmount.value = options.initialCommissionAmount ?? 0;
        commissionType.value = options.initialCommissionType ?? 'PERCENTAGE';
        priceType.value = options.initialPriceType ?? 'PERSON';
    }
    return {
        netPrice,
        commissionAmount,
        commissionType,
        priceType,
        taxRate,
        totalPrice,
        breakdown,
        commissionInCurrency,
        formattedTotal,
        formattedNet,
        formattedCommission,
        setNetPrice,
        setCommissionAmount,
        setCommissionType,
        setPriceType,
        reset,
    };
}
